// This declaration should normally be in shared.ts. However the build output seems to generate a
// structure that causes warnings for consumers. The built shared.js defines this enum and nothing
// else. The build doesn't seem to look at shared.d.js for more type information. When the
// shared.ts only exports types and interfaces, it is built as an empty file and this seems to
// cause the consumer builds to look at shared.d.ts for the complete type information.

// regions within Table component
export let TableRegions = /*#__PURE__*/function (TableRegions) {
  TableRegions[TableRegions["Data"] = 0] = "Data";
  TableRegions[TableRegions["ColumnHeader"] = 1] = "ColumnHeader";
  TableRegions[TableRegions["RowHeader"] = 2] = "RowHeader";
  TableRegions[TableRegions["ColumnRowHeader"] = 3] = "ColumnRowHeader";
  TableRegions[TableRegions["ColumnHeaderButton"] = 4] = "ColumnHeaderButton";
  TableRegions[TableRegions["ZeroStateOverlay"] = 5] = "ZeroStateOverlay";
  return TableRegions;
}({});
//# sourceMappingURL=TableRegions.js.map